import * as businessUnitConstants from './actionTypes';
import request from './Request';
import constants from '../../config/constants';
import {utils,writeFile} from 'xlsx';

export const getBusinessUnitList = (limit,page,search,filter) => {
  const params = filter?.filterBy || "ALL"

  return (dispatch) => {
    dispatch({
      type: businessUnitConstants.FETCH_BUSINESS_UNIT_LIST
    });
    request({
        method: 'get',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url:`${constants.BASE_URL}businessUnit/get?businessUnitName=${params}`,   
        params: {
            limit,
            page,
            search,
            filterBy: filter.filterBy,
            sortOrder : filter.sortValue.sortOrder || "desc",
            sortBy :filter.sortValue.sortBy ||"modifiedTime"
            // startDate: filter.startDate,
            // endDate: filter.endDate,
        }
    })
      .then((response) => {
        dispatch({
          type: businessUnitConstants.FETCH_BUSINESS_UNIT_LIST_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: businessUnitConstants.FETCH_BUSINESS_UNIT_LIST_FAILURE,
          payload: error?.response?.data
        });
      })
  }

}

export const getBusinessUnitDetails = (payload) => {
    return (dispatch) => {
      dispatch({
        type: businessUnitConstants.FETCH_BUSINESS_UNIT_DETAILS
      });
        request({
            method: 'get',
            headers:{
              "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            url:`${constants.BASE_URL}businessUnit/view?businessUnitName=${payload}`,
        })
        .then((response) => {
          dispatch({
            type: businessUnitConstants.FETCH_BUSINESS_UNIT_DETAILS_SUCCESS,
            payload: response
          });
        })
        .catch((error) => {
          dispatch({
            type: businessUnitConstants.FETCH_BUSINESS_UNIT_DETAILS_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  export const getBUnitFilterDetails = (payload) => {
    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

      return (dispatch) => {
        dispatch({
          type: businessUnitConstants.FETCH_BUNIT_FILTER_LIST
        });
          request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}lov/businessUnit/${userDetails?.userId}`,
          })
          .then((response) => {
            dispatch({
              type: businessUnitConstants.FETCH_BUNIT_FILTER_LIST_SUCCESS,
              payload: response.data
            });
          })
          .catch((error) => {
            dispatch({
              type: businessUnitConstants.FETCH_BUNIT_FILTER_LIST_FAILURE,
              payload: error?.response?.data
            });
          })
      }
    
    }
  export const createNewBusinessUnit = (payload) => {
  return (dispatch) => {
    dispatch({
      type: businessUnitConstants.CREATE_BUNIT
    });

    request({
        method: 'post',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url: `${constants.BASE_URL}businessUnit/create`,
        data : payload 
    })
    .then((response) => {
        dispatch({
          type: businessUnitConstants.CREATE_BUNIT_SUCCESS,
          payload: response.data
        });
    
    }).catch((error) => {
      dispatch({
        type: businessUnitConstants.CREATE_BUNIT_FAILURE,
        payload:error?.response?.data
      });
    });
  }

}
export const updateBusinessUnit = (payload) => {
  return (dispatch) => {
    dispatch({
      type: businessUnitConstants.UPDATE_BUNIT
    });

    request({
        method: 'post',
        url: `${constants.BASE_URL}businessUnit/update/${payload.businessUnitId}`,
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        data : payload 
    })
  .then((response) => {
      dispatch({
        type: businessUnitConstants.UPDATE_BUNIT_SUCCESS,
        payload: response.data
      });
  }).catch((error) => {
    dispatch({
      type: businessUnitConstants.UPDATE_BUNIT_FAILURE,
      payload:error?.response?.data
    });
  });
}

}
export const deleteBusinessUnit = (data) => {
  return (dispatch) => {
      dispatch({
        type: businessUnitConstants.DELETE_BUNIT,
      });
     
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}businessUnit/delete`,   
          data: data
      })
      .then((response) => {
        dispatch({
          type: businessUnitConstants.DELETE_BUNIT_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: businessUnitConstants.DELETE_BUNIT_FAILURE,
          payload: error?.response?.data
        });
      })

  }
}

export const getAllCountriesAndCurrency = (payload) => {
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

    return (dispatch) => {
        request({
            method: 'get',
            headers:{
              "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            url:`${constants.BASE_URL}lov/country/${userDetails?.userId}`,
        })
        .then((response) => {
          dispatch({
            type: businessUnitConstants.FETCH_COUNTRIES_LIST_SUCCESS,
            payload: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: businessUnitConstants.FETCH_COUNTRIES_LIST_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  export function exportReport(eData, tableobj) {

    // const data = new FormData();
    const response = tableobj;
    // data.append('filterBy', eData.filterBy);
    // data.append('fileId', eData.fileId);
    // data.append('startDate', eData.startDate);
    // data.append('endDate', eData.endDate);
  
    // return (dispatch) => {
    //   dispatch({
    //     type: businessUnitConstants.EXPORT_BUNIT_DATA,
    //   });
  
    //   request({
    //     method: 'post',
    // headers:{
    //   "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
    // },
    //     // url: `${config.API_URL}/api/messages/invalid/list/export/${userDetails?.accountId}/${userDetails?.userId}/`,
    //      data,
    //   }).then((response) => {
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([{"start Date":new Date(),"End Date":new Date()}])
      utils.sheet_add_json(ws,[{'Total Records' : response.data.totalCount}],{origin: "A5"})
      utils.sheet_add_json(ws,response?.data?.data?.map((item) => {
        const csvdata = {...item};
        return csvdata;
      }),{origin: "A8"})
      utils.book_append_sheet(wb,ws, 'Sheet1');
      writeFile(wb,`business-unit-report.xlsx`);
      // })
      //   .catch((error) => {
      //     dispatch({
      //       type: businessUnitConstants.EXPORT_BUNITDATA_FAILURE,
      //       payload: error
      //     });
        // })
  
    // }
  }